import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    extId: String,
    editorData: Object
  }

  connect() {
    // 해당 history item을 찾아서 notes--draft 컨트롤러에 editor_data 설정
    const historyItem = document.querySelector(`[data-post-history-item-ext-id-value="${this.extIdValue}"]`)

    if (historyItem) {
      // historyItem 자기 자신에 notes--draft 가 함께 붙어 있는 경우가 있어,
      // querySelector(자손만 탐색)에 의존하지 않고 자기 자신도 포함해서 찾는다.
      const draftElement = historyItem.matches('[data-controller~="notes--draft"]')
        ? historyItem
        : historyItem.querySelector('[data-controller~="notes--draft"]')

      if (draftElement) {
        // data attribute 업데이트
        draftElement.setAttribute('data-notes--draft-editor-data-value', JSON.stringify(this.editorDataValue))

        // Stimulus 컨트롤러 인스턴스 가져오기
        const controller = this.application.getControllerForElementAndIdentifier(draftElement, 'notes--draft')

        if (controller && controller.editorDataValue !== undefined) {
          controller.editorDataValue = this.editorDataValue
        }
      }
    }

    // 작업 완료 후 자신을 제거
    this.element.remove()
  }
}